<template>
	<div>
		<div class="menu-button">
			<i class="fas fa-info"></i>
			<a v-if="email" @click="emailToClient()">
				<i class="fas fa-envelope"></i>
			</a>
			<a v-if="contact" @click="callToClient()">
				<i class="fas fa-phone"></i>
			</a>
			<a @click="$bvModal.show('FAQUsers')">
				<i class="fas fa-question"></i>						
			</a>
		</div>
		<b-modal id="FAQUsers" size="lg" title="FAQ" body-class="hide-padding" hide-footer>
			<FAQUsers/>
		</b-modal>		
	</div>
</template>

<script>
import FAQUsers from '@/components/ui/FAQUsers.vue'

export default {
	components: {
		FAQUsers 
	},
	methods: {
	    emailToClient() {
			window.location.href = `mailto:${this.email}`;
		},
		callToClient() {
			window.location.href = `tel:${this.contact}`;
		}
	},
	props: {
		email: {
			type: String
		},
		contact: {
			type: String
		}
	}
}
</script>

<style lang="scss" scoped>
@import 'bourbon';

.menu-button {
	transition: 0.4s;
	position:fixed;
	z-index: 10000000 !important;
	right:10px;
	top :10px;
	width:60px;
	height:60px;
	text-align:center;
	line-height:60px;
	border-radius:50%;
	background-color:var(--bg);
	color:#FFFFFF;
	font-size:24px;
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26), 0 2px 10px 0 rgba(0, 0, 0, 0.22);
	cursor:pointer;
	&:hover{
		background:var(--bg);
		box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.28), 0 4px 15px 0 rgba(0, 0, 0, 0.25);
	}
	a{
		transition:.4s;
		opacity:0;
		width:0px;
		height:0px;
		text-align:center;
		line-height:50px;
		border-radius:50%;
		color:#FFFFFF;
		font-size:24px;
		box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26), 0 2px 10px 0 rgba(0, 0, 0, 0.22);
		cursor:pointer;
		&:hover{
			box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.28), 0 4px 15px 0 rgba(0, 0, 0, 0.25);
			color: var(--bg) !important;
		}
		&:nth-child(2){
			transition-delay: 0.3s;			
			position:absolute;
			right:30px;
			bottom:30px;
			background:var(--bg);
		}
		&:nth-child(3){
			transition-delay: 0.4s;	
			position:absolute;
			right:30px;
			top:30px;
			background:var(--bg);
		}
		&:nth-child(4){
			transition-delay: 0.5s;
			position:absolute;
			right:30px;
			top:30px;
			background:var(--bg);
		}
	}
	&:hover{
		a{
			opacity:1;
			width:50px;
			height:50px;
			&:nth-child(2){
				right:80px;
				bottom:0px;
				&:hover{
					transition-delay: 0s;	
					background:var(--primary);
				}
			}
			&:nth-child(3){
				right:65px;
				top:65px;
				&:hover{
					transition-delay: 0s;
					background:var(--primary);
				}
			}
			&:nth-child(4){
				right:5px;
				top:75px;
				&:hover{
					transition-delay: 0s;
					background:var(--primary);
				}
			}
		}
	}
	&:active{
		a{
			opacity:1;
			width:50px;
			height:50px;
			&:nth-child(2){
				right:80px;
				bottom:0px;
				&:hover{
					transition-delay: 0s;
					background:var(--primary);
				}
			}
			&:nth-child(3){
				right:65px;
				top:65px;
				&:hover{
					transition-delay: 0s;
					background:var(--primary);
				}
			}
			&:nth-child(4){
				right:5px;
				top:75px;
				&:hover{
					transition-delay: 0s;
					background:var(--primary);
				}
			}
		}
	}

}
</style>